<template>
  <pop-container :show="show">
    <div class="coupon-wrap no-px2rem" v-if="show" slot="content">
      <div :show="showContent">
        <div
          class="coupon-skin"
          v-lazy:background-image="lazyImgObj(couponConfig.skinUrl)"
          ref="couponImg">
          <div
            v-if="!loading"
            class="coupon-list"
            :style="`margin-bottom: ${!errmsg && couponConfig.btnText ? '' : '3px'}; background: ${errmsg && '#fff'}`">
            <template v-if="!errmsg">
              <coupon-cell
                v-for="(coupon, index) in couponList"
                :key="index"
                :coupon="coupon"
                :index="index"
                :couponLength="couponList.length"
                :hasDesc="hasDesc"
                @click="clickCoupon(coupon)"
              ></coupon-cell>
            </template>
            <p class="error-msg font-regular" v-else v-html="errmsg"></p>
          </div>
          <div 
            v-if="!loading && !errmsg && couponConfig.btnText"
            class="coupon-btn font-demi">
            <a v-if="couponConfig.btnUrl" @click="handleClick()">
              {{couponConfig.btnText}}
            </a>
            <a v-else @click="handleHide('button')">
              {{couponConfig.btnText}}
            </a>
          </div>
        </div>
      </div>
      <a v-if="!loading" class="close-btn">
        <img src="https://img0.didiglobal.com/static/soda_static/m/act/static/img/close_icon.png" @click="handleHide('button')">
      </a>
    </div>
  </pop-container>
</template>
<script>
import PopContainer from '@/components/pop-container'
import CouponCell from './couponCell'
import trackEvent from '@/common/js/track'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    couponConfig: {
      type: Object,
      default: {}
    },
    couponList: {
      type: Array,
      default: []
    },
    errmsg: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showContent: false,
      imgLoadingTime: 0, // 图片加载时间
      isImgLoaded: false // 图片是否已执行加载完成
    }
  },
  computed: {
    hasDesc () {
      if (this.couponList.length > 0 && this.couponList[0].description) {
        return true
      }
      return false
    }
  },
  components: {
    PopContainer,
    CouponCell
  },
  async mounted () {
    if (this.couponList.length > 0) {
      this.showContent = true
    }
    if (this.errmsg) {
      this.showContent = true
    }
    this.imgLoadingTime = new Date().getTime()
    let globalParams = await this.SodaBridge('getGlobalParams', 'badcase') || {}
    const {osType, osVersion} = globalParams.data
    if (+osType === 2 && +osVersion.split('.')[0] < 6) { // 安卓 6.0 以下的系统无法监听到lazyload事件
      this.$emit('onHideLoad', { imgLoadingTime: new Date().getTime() - this.imgLoadingTime })
    } else {
      this.$Lazyload.$on('loaded', () => {
        if (!this.isImgLoaded) {
          this.$emit('onHideLoad', { imgLoadingTime: new Date().getTime() - this.imgLoadingTime })
        }
        this.isImgLoaded = true
      })
    }
  },
  methods: {
    lazyImgObj (value) {
      return {
        src: value
      }
    },
    handleHide (clickPosi) {
      if (clickPosi === 'button') {
        this.trackClickClose({
          window_type: 1,
          activity_id: this.couponConfig.activityId
        })
      }
      this.$emit('onHide')
    },
    handleClick () {
      this.SodaBridge('openPage', {
        target: 'blank',
        url: this.couponConfig.btnUrl
      })
      this.$emit('onHide')
      trackEvent({
        eventId: 'sailing_c_x_window_continue_ck',
        eventLabel: '红包按钮点击',
        attrs: {
          window_type: 1,
          activity_id: this.couponConfig.activityId,
          postion: 2
        }
      })
    },
    // 点击关闭
    trackClickClose (options) {
      trackEvent({
        eventId: 'sailing_c_x_window_return_ck',
        eventLabel: '点击底部的X',
        attrs: {...options}
      })
    },
    // 券批次单次点击
    clickCoupon (coupon) {
      trackEvent({
        eventId: 'sailing_c_x_window_continue_ck',
        eventLabel: '红包点击',
        attrs: {
          window_type: 1,
          activity_id: this.couponConfig.activityId,
          postion: 1
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/main.scss";
@import "~@/assets/styles/var.scss";

.coupon-wrap.no-px2rem {
  max-height: 480px;
  width: 290px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .coupon-skin {
    max-height: 438px;
    min-height: 244px;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 5px;
    background-size: 100% auto;
    background-repeat: no-repeat;
    img {
      width: 100%;
      display: block;
    }
  }
  .coupon-list {
    margin: 93px 11px 0px 11px;
    overflow-y: auto;
    width: 280px;
  }
  .error-msg {
    font-size: 16px;
    padding: 53px 50px;
    color: #666666;
    text-align: center;
    line-height: 20px;
  }
  .coupon-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    @include button-font-color();
    @include background-gradient();
    border-radius: 2px;
    width: 100px;
    height: 38px;
    margin: 8px 0px 10px 0px;
    a {
      @include button-font-color()
      font-size: 14px;
      max-width: 80px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      text-align: center;
    }
  }
  .close-btn {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    img {
      width: 33px;
      height: 33px;
    }
  }
}
</style>
